import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetOemPassword, resetOemState } from "../../../redux/actions/oemActions";
import "../../../styles/DeleteConfirmModal.css"

const OEMResetPasswordModal = ({
  isOpen,
  onClose,
  onSave,
  currentPassword,
  partnerId,
  refreshParams,
}) => {
  const [newPassword, setNewPassword] = useState("");
  const [generating, setGenerating] = useState(false);
  const [previousSuccess, setPreviousSuccess] = useState(false);
  const dispatch = useDispatch();
  const { loading, success } = useSelector(state => state.oem);

  const validatePassword = (pwd) => {
    return {
      hasCapital: /[A-Z]/.test(pwd),
      hasSpecial: /[!@#$%^&*(),.?":{}|<>]/.test(pwd),
      hasNumber: /[0-9]/.test(pwd),
      hasMinLength: pwd.length >= 8
    };
  };
  
  const validation = validatePassword(newPassword);
  const isValid = validation.hasCapital && validation.hasSpecial && validation.hasNumber && validation.hasMinLength;

  useEffect(() => {
    if (isOpen) {
      setNewPassword(currentPassword || "");
    } else {
      dispatch(resetOemState());
    }
  }, [isOpen, currentPassword, dispatch]);

  useEffect(() => {
    if (success && !loading && isOpen && !previousSuccess) {
      setPreviousSuccess(true);
    }
    
    if (!success) {
      setPreviousSuccess(false);
    }
  }, [success, loading, isOpen, previousSuccess]);

  const generateRandomPassword = () => {
    setGenerating(true);
    setTimeout(() => {
      const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const lower = "abcdefghijklmnopqrstuvwxyz";
      const numbers = "0123456789";
      const special = "!@#$%^&*";
      
      let result = "";
      result += upper.charAt(Math.floor(Math.random() * upper.length));
      result += special.charAt(Math.floor(Math.random() * special.length));
      result += numbers.charAt(Math.floor(Math.random() * numbers.length));
      
      const allChars = upper + lower + numbers + special;
      for (let i = 3; i < 8; i++) {
        result += allChars.charAt(Math.floor(Math.random() * allChars.length));
      }
      
      result = result.split('').sort(() => Math.random() - 0.5).join('');
      setNewPassword(result);
      setGenerating(false);
    }, 500);
  };

  const handleSave = () => {
    if (!newPassword.trim() || !isValid) return;
    onSave(newPassword);
    dispatch(resetOemPassword({
      oemId: partnerId,
      password: newPassword,
      refreshParams
    }));
  };

  const handleClose = () => {
    dispatch(resetOemState());
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content-admin">
        <div className="modal-header">
          <h5>Reset Password</h5>
        </div>
        <div className="modal-body p-0">
          <div className="form-group">
            <label className="" style={{ textAlign: "left" }}>
              New Password:
            </label>
            <div className="d-flex gap-2">
              <input
                type="text"
                className="form-control"
                value={newPassword}
                onChange={(e) =>
                  setNewPassword(e.target.value.replace(/\s/g, ""))
                }
                placeholder="Enter new password"
              />
              <button
                type="button"
                className="btn-confirm"
                onClick={generateRandomPassword}
                disabled={generating}
              >
                {generating ? "Generating..." : "Generate"}
              </button>
            </div>
            {newPassword && (
              <small className="mt-2" style={{ display: 'block', color: isValid ? 'green' : '#666' }}>
                Password must contain:
                <span style={{ color: validation.hasCapital ? 'green' : 'red', marginLeft: '5px' }}>
                  {validation.hasCapital ? '✓' : '✗'} 1 Capital
                </span>
                <span style={{ color: validation.hasSpecial ? 'green' : 'red', marginLeft: '8px' }}>
                  {validation.hasSpecial ? '✓' : '✗'} 1 Special
                </span>
                <span style={{ color: validation.hasNumber ? 'green' : 'red', marginLeft: '8px' }}>
                  {validation.hasNumber ? '✓' : '✗'} 1 Number
                </span>
                <span style={{ color: validation.hasMinLength ? 'green' : 'red', marginLeft: '8px' }}>
                  {validation.hasMinLength ? '✓' : '✗'} Min 8 chars
                </span>
              </small>
            )}
          </div>
        </div>
        <div className="mt-3">
          <button className="cancel-btn ms-0" onClick={handleClose}>
            Cancel
          </button>
          <button
            className="btn-confirm ms-2"
            style={{width:"72%"}}
            onClick={handleSave}
            disabled={loading || !newPassword.trim() || !isValid}
          >
            {loading ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OEMResetPasswordModal;
